module.exports = {
  slick: {
    //Slick default config
    autoplay: false,
    dots: false,
    infinite: true,
    arrows: true,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow: '<button class="slider-arrow slider-arrow--prev"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg/svg-use-sprite.svg#arrow-left"></use></svg><span class="a11y">Previous</span></button>',
    nextArrow: '<button class="slider-arrow slider-arrow--next"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg/svg-use-sprite.svg#arrow-right"></use></svg><span class="a11y">Next</span></button>'

  },
  maps: {
    //Google maps default config
    defaultPin: {
      url: '/assets/images/map-pin.svg',
      width: 36,
      height: 54
    },
    api: {
      KEY: 'AIzaSyDyxLx1XP_ePZz-A535dAY2hYbg9kOQEik',
      SENSOR: false,
      LIBRARIES: ['places']
    },
    center: {
      lat: -24.939602,
      lng: 31.578375
    },
    defaults: {
      zoom: 3,
      maxZoom: 15,
      minZoom: 1,
      disableDefaultUI: false,
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: true,
      zoomControl: true
    },
    cluster: {
      gridSize: 50,
      maxZoom: 10
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./source/scripts/config.js
// module id = 296
// module chunks = 0